// WordPress plugin download URL — served from Cloudflare R2.
// Updated by scripts/upload-wp-plugin.sh after each build.
export const WP_PLUGIN_DOWNLOAD_URL = 'https://pub-f0e4def27241429a82cb597e3d7e5c4c.r2.dev/plugins/one-email.zip'
